/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: eWewIpqBvzmf

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicErrorSection.module.css"; // plasmic-import: eWewIpqBvzmf/css

createPlasmicElementProxy;

export type PlasmicErrorSection__VariantMembers = {};
export type PlasmicErrorSection__VariantsArgs = {};
type VariantPropType = keyof PlasmicErrorSection__VariantsArgs;
export const PlasmicErrorSection__VariantProps = new Array<VariantPropType>();

export type PlasmicErrorSection__ArgsType = {
  icon?: React.ReactNode;
  error?: any;
};
type ArgPropType = keyof PlasmicErrorSection__ArgsType;
export const PlasmicErrorSection__ArgProps = new Array<ArgPropType>(
  "icon",
  "error"
);

export type PlasmicErrorSection__OverridesType = {
  main?: Flex__<"section">;
  wrapper?: Flex__<"div">;
  iconWrapper?: Flex__<"div">;
  content?: Flex__<"div">;
  title?: Flex__<"div">;
  nav?: Flex__<"div">;
  goBackBtn?: Flex__<"button">;
  homePageBtn?: Flex__<"a"> & Partial<LinkProps>;
  link?: Flex__<"a"> & Partial<LinkProps>;
};

export interface DefaultErrorSectionProps {
  icon?: React.ReactNode;
  error?: any;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicErrorSection__RenderFunc(props: {
  variants: PlasmicErrorSection__VariantsArgs;
  args: PlasmicErrorSection__ArgsType;
  overrides: PlasmicErrorSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          error: {
            code: 404,
            title: "Page Not Found",
            subtitle:
              "Oops! It looks like you've ventured off the beaten path.\nDon't worry, we'll help you find your way back.\nTry returning to the homepage or use the menu at the top.",
            primaryAction: "Go Back"
          }
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"main"}
      data-plasmic-override={overrides.main}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.main
      )}
    >
      <div
        data-plasmic-name={"wrapper"}
        data-plasmic-override={overrides.wrapper}
        className={classNames("all", sty.wrapper)}
      >
        <div
          data-plasmic-name={"iconWrapper"}
          data-plasmic-override={overrides.iconWrapper}
          className={classNames("all", sty.iconWrapper)}
        >
          {renderPlasmicSlot({
            defaultContents: null,
            value: args.icon
          })}
        </div>
      </div>
      <div
        data-plasmic-name={"content"}
        data-plasmic-override={overrides.content}
        className={classNames("all", sty.content)}
      >
        <div
          data-plasmic-name={"title"}
          data-plasmic-override={overrides.title}
          className={classNames("all", sty.title)}
        >
          <div className={classNames("all", "__wab_text", sty.text__jb0XZ)}>
            <React.Fragment>
              {(() => {
                try {
                  return $props.error.code;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return "";
                  }
                  throw e;
                }
              })()}
            </React.Fragment>
          </div>
          <div className={classNames("all", "__wab_text", sty.text__fRbnz)}>
            <React.Fragment>
              {(() => {
                try {
                  return $props.error.title;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return "";
                  }
                  throw e;
                }
              })()}
            </React.Fragment>
          </div>
        </div>
        <div
          className={classNames("all", "__wab_text", sty.text__mqh)}
          style={(() => {
            try {
              return {
                "white-space": "break-all;"
              };
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.error.subtitle;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </div>
        <div
          data-plasmic-name={"nav"}
          data-plasmic-override={overrides.nav}
          className={classNames("all", sty.nav)}
        >
          <button
            data-plasmic-name={"goBackBtn"}
            data-plasmic-override={overrides.goBackBtn}
            className={classNames(
              "all",
              "button",
              "button__bvRZj",
              sty.goBackBtn
            )}
            onClick={async event => {
              const $steps = {};

              $steps["runCode"] = true
                ? (() => {
                    const actionArgs = {
                      customFunction: async () => {
                        return $props.error.code === 500
                          ? window.location.reload()
                          : window.history.back();
                      }
                    };
                    return (({ customFunction }) => {
                      return customFunction();
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runCode"] != null &&
                typeof $steps["runCode"] === "object" &&
                typeof $steps["runCode"].then === "function"
              ) {
                $steps["runCode"] = await $steps["runCode"];
              }
            }}
            ref={ref => {
              $refs["goBackBtn"] = ref;
            }}
          >
            <div className={classNames("all", "__wab_text", sty.text__nd3Xf)}>
              <React.Fragment>{$props.error.primaryAction}</React.Fragment>
            </div>
          </button>
          <PlasmicLink__
            data-plasmic-name={"homePageBtn"}
            data-plasmic-override={overrides.homePageBtn}
            className={classNames("all", "a", "a__bvRZj", sty.homePageBtn)}
            component={Link}
            href={"/New/Home.aspx"}
            legacyBehavior={false}
            platform={"nextjs"}
          >
            <div className={classNames("all", "__wab_text", sty.text__vz5Ro)}>
              {"Home Page"}
            </div>
          </PlasmicLink__>
        </div>
        <div className={classNames("all", "__wab_text", sty.text__mvNvr)}>
          <React.Fragment>
            <React.Fragment>
              {
                "If this issue persists, please screenshot it and send it to us\nwith a brief description at "
              }
            </React.Fragment>
            {
              <PlasmicLink__
                data-plasmic-name={"link"}
                data-plasmic-override={overrides.link}
                className={classNames(
                  "all",
                  "a",
                  "a__bvRZj",
                  "__wab_text",
                  "plasmic_default__inline",
                  sty.link
                )}
                component={Link}
                href={"mailto:support@myevaluations.com"}
                legacyBehavior={false}
                platform={"nextjs"}
              >
                {"support@myevaluations.com"}
              </PlasmicLink__>
            }
            <React.Fragment>{"."}</React.Fragment>
          </React.Fragment>
        </div>
      </div>
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  main: [
    "main",
    "wrapper",
    "iconWrapper",
    "content",
    "title",
    "nav",
    "goBackBtn",
    "homePageBtn",
    "link"
  ],
  wrapper: ["wrapper", "iconWrapper"],
  iconWrapper: ["iconWrapper"],
  content: ["content", "title", "nav", "goBackBtn", "homePageBtn", "link"],
  title: ["title"],
  nav: ["nav", "goBackBtn", "homePageBtn"],
  goBackBtn: ["goBackBtn"],
  homePageBtn: ["homePageBtn"],
  link: ["link"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  main: "section";
  wrapper: "div";
  iconWrapper: "div";
  content: "div";
  title: "div";
  nav: "div";
  goBackBtn: "button";
  homePageBtn: "a";
  link: "a";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicErrorSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicErrorSection__VariantsArgs;
    args?: PlasmicErrorSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicErrorSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicErrorSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicErrorSection__ArgProps,
          internalVariantPropNames: PlasmicErrorSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicErrorSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "main") {
    func.displayName = "PlasmicErrorSection";
  } else {
    func.displayName = `PlasmicErrorSection.${nodeName}`;
  }
  return func;
}

export const PlasmicErrorSection = Object.assign(
  // Top-level PlasmicErrorSection renders the root element
  makeNodeComponent("main"),
  {
    // Helper components rendering sub-elements
    wrapper: makeNodeComponent("wrapper"),
    iconWrapper: makeNodeComponent("iconWrapper"),
    content: makeNodeComponent("content"),
    title: makeNodeComponent("title"),
    nav: makeNodeComponent("nav"),
    goBackBtn: makeNodeComponent("goBackBtn"),
    homePageBtn: makeNodeComponent("homePageBtn"),
    link: makeNodeComponent("link"),

    // Metadata about props expected for PlasmicErrorSection
    internalVariantProps: PlasmicErrorSection__VariantProps,
    internalArgProps: PlasmicErrorSection__ArgProps
  }
);

export default PlasmicErrorSection;
/* prettier-ignore-end */
